import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Import translation hook
import '../../style/AddDiseasePage.css'; // Import the CSS file

const AddDiseasePage = () => {
    const { id } = useParams(); // Get pet ID from URL
    const navigate = useNavigate(); // For redirection
    const { t } = useTranslation(); // Translation function
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000'; // Backend URL
    const [newDisease, setNewDisease] = useState({
        name: '',
        diagnosisDate: '',
        notes: '',
    });
    const [error, setError] = useState(null);

    const handleCreateDisease = async () => {
        try {
            const storedUser = JSON.parse(localStorage.getItem('user')); // Retrieve user data from localStorage
            const token = storedUser?.token;

            if (!token) {
                throw new Error(t('general.noAuthToken')); // Use translation for error
            }

            // Create the disease
            const diseaseResponse = await fetch(`${baseUrl}/api/pets/${id}/conditions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`, // Include token in Authorization header
                },
                body: JSON.stringify({
                    name: newDisease.name,
                    type: 'disease', // Specify type as 'disease'
                    diagnosisDate: newDisease.diagnosisDate,
                    notes: newDisease.notes,
                }),
            });

            if (!diseaseResponse.ok) {
                throw new Error(t('disease.createFailed')); // Use translation for error
            }

            const addedDisease = await diseaseResponse.json(); // Expect the backend to return only the newly created disease
            console.log(addedDisease); // Debug log

            if (!addedDisease._id) {
                throw new Error(t('disease.missingDiseaseId')); // Use translation for error
            }

            navigate(`/pet/${id}/conditions/${addedDisease._id}`); // Redirect to the Condition Page
        } catch (error) {
            setError(error.message);
            console.error(error);
        }
    };

    return (
        <div className="add-disease-form bg-dafauna-background rounded-xl shadow-md p-8">
            <h3 className="text-dafauna-darkText text-2xl font-bold text-center mb-4">{t('disease.title')}</h3>
            {error && <p className="error-message text-red-500 text-center">{error}</p>}
            <div className="form-group">
                <label htmlFor="diseaseName" className="block text-dafauna-darkText font-medium mb-2">
                    {t('condition.diseaseName')}
                </label>
                <input
                    type="text"
                    id="diseaseName"
                    placeholder={t('condition.diseaseNamePlaceholder')}
                    value={newDisease.name}
                    onChange={(e) => setNewDisease({ ...newDisease, name: e.target.value })}
                    required
                    className="form-input border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                />
            </div>
            <div className="form-group">
                <label htmlFor="diagnosisDate" className="block text-dafauna-darkText font-medium mb-2">
                    {t('condition.diagnosisDate')}
                </label>
                <input
                    type="date"
                    id="diagnosisDate"
                    placeholder={t('condition.diagnosisDatePlaceholder')}
                    value={newDisease.diagnosisDate}
                    onChange={(e) => setNewDisease({ ...newDisease, diagnosisDate: e.target.value })}
                    required
                    className="form-input border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                />
            </div>
            <div className="form-group">
                <label htmlFor="notes" className="block text-dafauna-darkText font-medium mb-2">
                    {t('condition.notes')}
                </label>
                <textarea
                    id="notes"
                    placeholder={t('condition.notesPlaceholder')}
                    value={newDisease.notes}
                    onChange={(e) => setNewDisease({ ...newDisease, notes: e.target.value })}
                    className="form-textarea border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                />
            </div>
            <button
                onClick={handleCreateDisease}
                className="create-disease-page-btn w-full bg-dafauna-primary text-white rounded-md px-4 py-2 hover:bg-dafauna-primaryLight disabled:bg-gray-300 disabled:cursor-not-allowed"
            >
                {t('disease.createButton')}
            </button>
        </div>
    );
};

export default AddDiseasePage;